import { useField } from "formik";

const TextAreaInput = (props) => {
  const { label, name,  style } = props;
  const [field, meta] = useField(name);

  const configTextfield = {
    ...field,
    error: false,
    value: field.value,
  };

  if (meta && meta.touched && meta.error) {
    configTextfield.error = true;
    configTextfield.helperText = meta.error;
  }
  return (
    <div
      className={
        meta && meta.touched && meta.error
          ? "form-input error-form"
          : "form-input"
      }
    >
      <label htmlFor={name}>{label}</label>
      <textarea
        name={name}
        {...configTextfield}
        style={style}
        className={
          meta && meta.touched && meta.error
            ? "error form-control"
            : "form-control"
        }
        rows={5}
      />
      {meta && meta.touched && meta.error ? (
        <div className="error">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default TextAreaInput;
